import { initialQuery } from '../../../model/constants.tsx';
import { SET_QUERY, PATCH_QUERY, type Action } from '../../actions/query/index.tsx';
import type { QueryState } from './types.tsx';

export const initialState: QueryState = initialQuery;

const query = (state: QueryState = initialState, action: Action): QueryState => {
	switch (action.type) {
		case SET_QUERY:
			return action.payload;
		case PATCH_QUERY:
			return {
				...state,
				...action.payload,
			};
		default: {
			const _exhaustiveCheck: never = action;
			return state;
		}
	}
};

export default query;
